// extracted by mini-css-extract-plugin
export default {"form":"EditForm_form__IsrDR","name":"EditForm_name__jZulb"};